import { render, staticRenderFns } from "./BarStackChart.vue?vue&type=template&id=2e948177&"
import script from "./BarStackChart.vue?vue&type=script&lang=js&"
export * from "./BarStackChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports